import { Type } from '../../types/type';
import { validateFormat } from './format';
import { validateMaxLength } from './max-length';
import { validateMinLength } from './min-length';
import { validateType } from './type';
/**
 * Creates a validator function that checks that the value is a `string` and optionally validates its length.
 * @param options The validation options to be enforced.
 */
export const validateString = (options = {}) => {
    const { minLength, maxLength, format } = options;
    if (minLength !== undefined && maxLength !== undefined && maxLength < minLength) {
        throw new Error('maxLength cannot be less than minLength.');
    }
    return (value, logger, logLabel) => {
        if (!validateType(Type.String)(value, logger, logLabel))
            return false;
        if (!validateMinLength(minLength)(value, logger, logLabel))
            return false;
        if (!validateMaxLength(maxLength)(value, logger, logLabel))
            return false;
        if (!validateFormat(format)(value, logger, logLabel))
            return false;
        return true;
    };
};
//# sourceMappingURL=string.js.map